export const images = [
  {
    src: "/images/highlights/1.jpeg",
    original: "/images/highlights/1.jpeg",
    width: 800,
    height: 500,
    caption: "Culture Beat Photo",
  },{
    src: "/images/highlights/2.jpeg",
    original: "/images/highlights/2.jpeg",
    width: 800,
    height: 500,
    caption: "Culture Beat Photo",
  },{
    src: "/images/highlights/3.jpeg",
    original: "/images/highlights/3.jpeg",
    width: 800,
    height: 500,
    caption: "Culture Beat Photo",
  },{
    src: "/images/highlights/4.jpeg",
    original: "/images/highlights/4.jpeg",
    width: 800,
    height: 500,
    caption: "Culture Beat Photo",
  },{
    src: "/images/highlights/5.jpeg",
    original: "/images/highlights/5.jpeg",
    width: 800,
    height: 500,
    caption: "Culture Beat Photo",
  },{
    src: "/images/highlights/6.jpeg",
    original: "/images/highlights/6.jpeg",
    width: 800,
    height: 500,
    caption: "Culture Beat Photo",
  },{
    src: "/images/highlights/7.jpeg",
    original: "/images/highlights/7.jpeg",
    width: 800,
    height: 500,
    caption: "Culture Beat Photo",
  },{
    src: "/images/highlights/8.jpeg",
    original: "/images/highlights/8.jpeg",
    width: 800,
    height: 500,
    caption: "Culture Beat Photo",
  },{
    src: "/images/highlights/9.jpeg",
    original: "/images/highlights/9.jpeg",
    width: 800,
    height: 500,
    caption: "Culture Beat Photo",
  },{
    src: "/images/highlights/10.jpeg",
    original: "/images/highlights/10.jpeg",
    width: 800,
    height: 500,
    caption: "Culture Beat Photo",
  },{
    src: "/images/highlights/11.jpeg",
    original: "/images/highlights/11.jpeg",
    width: 800,
    height: 500,
    caption: "Culture Beat Photo",
  },{
    src: "/images/highlights/12.jpeg",
    original: "/images/highlights/12.jpeg",
    width: 800,
    height: 500,
    caption: "Culture Beat Photo",
  },{
    src: "/images/highlights/13.jpeg",
    original: "/images/highlights/13.jpeg",
    width: 800,
    height: 500,
    caption: "Culture Beat Photo",
  },{
    src: "/images/highlights/14.jpeg",
    original: "/images/highlights/14.jpeg",
    width: 800,
    height: 500,
    caption: "Culture Beat Photo",
  },{
    src: "/images/highlights/15.jpeg",
    original: "/images/highlights/15.jpeg",
    width: 800,
    height: 500,
    caption: "Culture Beat Photo",
  },{
    src: "/images/highlights/16.jpeg",
    original: "/images/highlights/16.jpeg",
    width: 800,
    height: 500,
    caption: "Culture Beat Photo",
  },{
    src: "/images/highlights/17.jpeg",
    original: "/images/highlights/17.jpeg",
    width: 800,
    height: 500,
    caption: "Culture Beat Photo",
  },{
    src: "/images/highlights/18.jpeg",
    original: "/images/highlights/18.jpeg",
    width: 800,
    height: 500,
    caption: "Culture Beat Photo",
  },{
    src: "/images/highlights/19.jpeg",
    original: "/images/highlights/19.jpeg",
    width: 800,
    height: 500,
    caption: "Culture Beat Photo",
  },{
    src: "/images/highlights/20.jpeg",
    original: "/images/highlights/20.jpeg",
    width: 800,
    height: 500,
    caption: "Culture Beat Photo",
  },{
    src: "/images/highlights/21.jpeg",
    original: "/images/highlights/21.jpeg",
    width: 800,
    height: 500,
    caption: "Culture Beat Photo",
  },{
    src: "/images/highlights/22.jpeg",
    original: "/images/highlights/22.jpeg",
    width: 800,
    height: 500,
    caption: "Culture Beat Photo",
  },{
    src: "/images/highlights/23.jpeg",
    original: "/images/highlights/23.jpeg",
    width: 800,
    height: 500,
    caption: "Culture Beat Photo",
  },{
    src: "/images/highlights/24.jpeg",
    original: "/images/highlights/24.jpeg",
    width: 800,
    height: 500,
    caption: "Culture Beat Photo",
  },{
    src: "/images/highlights/25.jpeg",
    original: "/images/highlights/25.jpeg",
    width: 800,
    height: 500,
    caption: "Culture Beat Photo",
  },{
    src: "/images/highlights/26.jpeg",
    original: "/images/highlights/26.jpeg",
    width: 800,
    height: 500,
    caption: "Culture Beat Photo",
  },{
    src: "/images/highlights/27.jpeg",
    original: "/images/highlights/27.jpeg",
    width: 800,
    height: 500,
    caption: "Culture Beat Photo",
  },{
    src: "/images/highlights/28.jpeg",
    original: "/images/highlights/28.jpeg",
    width: 800,
    height: 500,
    caption: "Culture Beat Photo",
  },{
    src: "/images/highlights/29.jpeg",
    original: "/images/highlights/29.jpeg",
    width: 800,
    height: 500,
    caption: "Culture Beat Photo",
  },{
    src: "/images/highlights/30.jpeg",
    original: "/images/highlights/30.jpeg",
    width: 800,
    height: 500,
    caption: "Culture Beat Photo",
  }
];